import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/safiruni/front/app/[lang]/universities/[id]/Components/HeaderSection.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/safiruni/front/app/[lang]/universities/[id]/Components/NavigationMenu.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/safiruni/front/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/var/www/safiruni/front/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/var/www/safiruni/front/public/images/bgLinear.png");
